import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppFromPath } from '../enum/UrlAppMap';

interface DocumentTitleConfig {
  baseTitle?: string;
  homeLabel?: string;
}

/**
 * Custom hook to automatically update the document title based on the current route
 * @param config Configuration object for title settings
 */
export const useDocumentTitle = (config: DocumentTitleConfig = {}) => {
  const location = useLocation();
  const { baseTitle = 'Brady Sales Assistant', homeLabel = 'Home' } = config;

  useEffect(() => {
    const appName = getAppFromPath(location.pathname);
    document.title = appName === homeLabel ? baseTitle : appName;
  }, [location.pathname, baseTitle, homeLabel]);
};
